<template>
  <li class="vt-dropdown__content-items-item"
      :class="{ 'vt-dropdown__content-items-item--checked': checked }"
    >
    <button @mousedown.prevent="selectOption">{{ text }}</button>
  </li>
</template>

<script>
export default {
  name: 'nt-option',
  props: {
    text: {
      default: null,
    },
    value: {
      default: null,
    },
    selected: {
      default: false
    }
  },
  computed: {
    checked() {
      return this.$parent.$data.item.text === this.text
    },
  },
  created() {
    if (!this.selected) return

    this.selectOption()
  },
  methods: {
    selectOption() {
      this.$parent.$emit('changeOption', {
        text: this.text,
        value: this.value
      })
    }
  }
}
</script>

<style lang="scss">
.vt-dropdown__content-items-item {
  $item: &;
  display: block;
  list-style: none;
  // word-break: break-all;
  // padding: 16px 20px;
  position: relative;

  & button {
    width: 100%;
    font-size: 16px;
    color: #eee;
    padding: 16px 20px;
  }

  &--checked {
    & button {
      background-color: #4e4e4e;
    }
  }
  &:not(:last-of-type) {
    // border-bottom: 1px solid rgb(238, 238, 238);
  }
  &:not(#{$item}--checked):hover {
    cursor: pointer;
    background-color: #4e4e4e;
  }
}
</style>
